import React from "react";
import AsiaPayoutOrchestrator from "../../shared/AsiaPayoutOrchestrator";
import { philippinesConfig } from "./config";

const PhilippinesPayout: React.FC = () => {
  return <AsiaPayoutOrchestrator config={philippinesConfig} />;
};

export default PhilippinesPayout;
